import { memo } from 'react';
import styled, { css } from 'styled-components';
import { spacing, typography, colors, IconErrorFilledSmall } from '@izettle/otto';
import { Icon } from '../icon/index.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import { SemanticState } from '../../enumerations/semantic-state.js';

const StyledIcon = /*#__PURE__*/styled(Icon).withConfig({
  displayName: "input-message__StyledIcon",
  componentId: "zettle__sc-16vihpz-0"
})(["margin-right:", ";"], spacing.xxSmall);
const mixinTypography = css`
  ${_ref => {
  let {
    semanticState
  } = _ref;
  return {
    [SemanticState.Warning]: typography.small,
    [SemanticState.Error]: typography.small,
    [SemanticState.Success]: typography.small,
    [SemanticState.Default]: typography.smallSecondary
  }[semanticState ?? SemanticState.Default];
}}
`;
const mixinColor = css`
  color: ${_ref2 => {
  let {
    semanticState
  } = _ref2;
  return {
    [SemanticState.Warning]: colors.text.warning,
    [SemanticState.Error]: colors.text.error,
    [SemanticState.Success]: colors.text.success,
    [SemanticState.Default]: colors.text.default
  }[semanticState ?? SemanticState.Default];
}};
`;
const InputMessageMemoized = /*#__PURE__*/memo(styled.p.withConfig({
  displayName: "input-message__InputMessageMemoized",
  componentId: "zettle__sc-16vihpz-1"
})(["margin-top:", ";padding-left:", ";", " ", ""], spacing.xxSmall, spacing.small, mixinTypography, mixinColor));
const InputMessage = _ref3 => {
  let {
    children,
    ...props
  } = _ref3;
  return /*#__PURE__*/jsxs(InputMessageMemoized, {
    ...props,
    children: [props.semanticState === SemanticState.Error && /*#__PURE__*/jsx(StyledIcon, {
      svgIcon: IconErrorFilledSmall
    }), children]
  });
};

export { InputMessage };
//# sourceMappingURL=index.js.map
